import { ChevronDownIcon } from "@primer/octicons-react";
import { Button, SelectPanel } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { tinhTrangHonNhanApi } from "../../api/tinhTrangHonNhanApi";
import { useCommonContext } from '../../contexts/common';
interface IComboboxTinhTrangHonNhanProps {
    isReadonly?: boolean;
    value?: number;
    onValueChanged: (id: number, data?: any) => void;
    className?: string;
    isShowClearButton?: boolean;
    preText?: string;
    width?: string | number;
    stylingMode?: 'outlined' | 'filled' | 'underlined';
};
const ComboboxTinhTrangHonNhan = (props: IComboboxTinhTrangHonNhanProps) => {
    const [TinhTrangHonNhan, setTinhTrangHonNhan] = useState<any[]>([]);

    const [open, setOpen] = useState(false)
    const [filter, setFilter] = useState('')

    const { translate } = useCommonContext();
    const dataSource = useMemo(() => {
        return TinhTrangHonNhan.map(x => ({ id: x.id, text: x.name }))
    }, [TinhTrangHonNhan])
    const filteredItems = useMemo(() => {
        return dataSource.filter(item => item.text.toLowerCase().includes(filter.toLowerCase()))
    }, [dataSource, filter])
    const selected = useMemo(() => {
        return dataSource.find(x => x.id === props.value)
    }, [dataSource, props.value])

    useEffect(() => {
        handleGetTinhTrangHonNhanAsync();
    }, [])

    const setSelected = (selecteds: any) => {
        if (selecteds)
            props.onValueChanged(selecteds.id)
    }
    const handleGetTinhTrangHonNhanAsync = async () => {
        const res = await tinhTrangHonNhanApi.selectAll();
        if (res.is_success) {
            setTinhTrangHonNhan(res.data)
        }
    }
    return (
        <SelectPanel
            renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
                <Button
                    trailingAction={ChevronDownIcon}
                    aria-labelledby={` ${ariaLabelledBy}`} {...anchorProps}
                    sx={{
                        width: '100%'
                    }}
                    className="button-left"
                >
                    <p style={{ maxWidth: '100%', overflow: "hidden", textOverflow: "ellipsis" }}>
                        {children || translate("Chọn tình trạng hôn nhân")}
                    </p>
                </Button>
            )}

            title={""}
            placeholderText="Search"
            open={open}
            onOpenChange={setOpen}
            items={filteredItems}
            selected={selected}
            onSelectedChange={setSelected}
            onFilterChange={setFilter}
            showItemDividers={true}
            overlayProps={{ width: 'small', height: 'medium' }}
        />

    );
};

export default ComboboxTinhTrangHonNhan;